import { Bug, BookOpen, CheckSquare, Layers, GitBranch, ChevronsUp, ChevronUp, Minus, ChevronDown, ChevronsDown } from "lucide-react";

export const ISSUE_TYPES = [
  { id: "epic", label: "Epic", icon: Layers, cls: "text-purple-500" },
  { id: "story", label: "Story", icon: BookOpen, cls: "text-emerald-500" },
  { id: "task", label: "Task", icon: CheckSquare, cls: "text-sky-500" },
  { id: "bug", label: "Bug", icon: Bug, cls: "text-red-500" },
  { id: "subtask", label: "Subtask", icon: GitBranch, cls: "text-slate-500" },
];

export const PRIORITIES = [
  { id: "highest", label: "Highest", icon: ChevronsUp, cls: "text-red-500" },
  { id: "high", label: "High", icon: ChevronUp, cls: "text-orange-500" },
  { id: "medium", label: "Medium", icon: Minus, cls: "text-amber-500" },
  { id: "low", label: "Low", icon: ChevronDown, cls: "text-sky-500" },
  { id: "lowest", label: "Lowest", icon: ChevronsDown, cls: "text-slate-500" },
];

export const STATUSES = [
  { id: "todo", label: "To Do" },
  { id: "in_progress", label: "In Progress" },
  { id: "in_review", label: "In Review" },
  { id: "done", label: "Done" },
];

export const typeMeta = (id) => ISSUE_TYPES.find((t) => t.id === id) || ISSUE_TYPES[2];
export const prioMeta = (id) => PRIORITIES.find((p) => p.id === id) || PRIORITIES[2];
export const statusMeta = (id) => STATUSES.find((s) => s.id === id) || STATUSES[0];

export const initials = (name) => (name || "?").split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();
